<template>
  <Layout2
    title="Set a password"
    padTop="50px"
  >
    <template slot="form">
      <form @submit.prevent="setPassword()">
        <div class="form-floating mb15">
          <input
            type="password"
            id="password"
            placeholder="Create New Password"
            class="form-control fn14"
            name="password"
            v-model="password"
            v-validate="{required:true, regex: $store.state.passwordRegex}"
          />
          <label for="password">Create New Password</label>
          <small class="col_error" v-show="errors.has('password')">{{ errors.first('password') }}</small>
        </div>
        <div class="form-floating mb15">
          <input
            type="password"
            id="confirmPassword"
            placeholder="Re-enter Password to Confirm"
            class="form-control fn14"
            name="confirmPassword"
            v-model="confirmPassword"
            v-validate="{required:true, confirmed: password}"
          />
          <label for="confirmPassword">Re-enter Password to Confirm</label>
          <small class="col_error" v-show="errors.has('confirmPassword')">{{ errors.first('confirmPassword') }}</small>
        </div>
        <div class="mt30">
          <label class="col_grey75 mb15">Password Strength</label>
          <div class="progress" style="height: 5px;">
            <div class="progress-bar bg_new_green" role="progressbar" :style="{width: `${progress}%`}" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100"></div>
          </div>
          <div class="mt15">
            <ul class="m0 p0 ls-none col_grey75">
              <li v-for="(e, i) in rules" :key="i">
                <v-icon :class="[e.value? 'col_new_green': 'col_white']">check</v-icon>
                <span>{{ e.label }}</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="form-floating mt30">
          <input type="submit" class="btn btn-apiculus-primary" value="TAKE ME TO THE CLOUD" />
        </div>
      </form>
    </template>
  </Layout2>
</template>

<script>
  import Layout2 from './Layout2.vue'
  import VueCookie from 'vue-cookie'
import helpers from '../../services/toast-service'
import crypto from 'crypto';
  export default {
    name: 'ResetUserPassword',
    mixins: [helpers],
    data () {
    return {
      password: '',
      confirmPassword: '',
      minLength: this.$store.state.ApiculusEnv.passwords.minLength,
      maxLength: this.$store.state.ApiculusEnv.passwords.maxLength,
      data: {},
      color: '',
      message: '',
      progress: 0,
      rules: [
        { label: 'Uppercase character (A-Z)', regex: /(?=.*[A-Z])/gm, value: false },
        { label: 'Lowercase character (a-z)', regex: /(?=.*[a-z])/gm, value: false },
        { label: 'Number (0-9)', regex: /(?=.*[0-9])/gm, value: false },
        { label: 'Special character (!,@,#,$,%,&,*,-)', regex: /(?=.*[!,@,#,$,%,&,*,-])/gm, value: false }
      ],
      publicKey: this.$store.state.ApiculusEnv.publicKey.replace(/ /g, '').replace('BEGINPUBLICKEY', 'BEGIN PUBLIC KEY').replace('ENDPUBLICKEY', 'END PUBLIC KEY'),
      passwordEncryptionOnLogin: this.$store.state.ApiculusEnv.features.passwordEncryptionOnLogin
    }},
    created () {
      this.rules.push({ 
        label: this.minLength + ' - ' + this.maxLength + ' characters long',
        regex: new RegExp('^[a-zA-Z0-9,!,@,#,$,%,&,*]{' + this.minLength +',' + this.maxLength +'}$'),
        value: false
      })
      this.data = JSON.parse(VueCookie.get('userData')) || {}
      if (!(Object.keys(this.data).length > 0)) {
        this.$router.push('/')
      }
    },
    computed: {
      confirmDialog () {
        let isValid = true
        isValid = (this.password && (this.password === this.confirmPassword))
        return isValid
      }
    },
    destroyed () {
      VueCookie.delete('userData')
    },
    methods: {
      setPassword () {
        const encryptedPassword = crypto.publicEncrypt(this.publicKey,
          Buffer.from(this.password, 'utf-8')
        )
        const encryptedConfirmPassword = crypto.publicEncrypt(this.publicKey,
          Buffer.from(this.password, 'utf-8')
        )
        this.$validator.validateAll().then(res => {
          if (res) {
          this.$set(this.data, 'password', this.passwordEncryptionOnLogin ? encryptedPassword : this.password)
          this.$set(this.data, 'confirmPassword', this.passwordEncryptionOnLogin ? encryptedConfirmPassword: this.confirmPassword)
          this.$store.dispatch('ACTION_RESET_PASSWORD', { ...this.data }).then(res => {
            if (res && res.alreadyUsed) {
              this.toastAlert(res.error.message || 'Something went wrong.', 'error')
            } else if (!res.success) {
              this.toastAlert(res.error.message || 'Something went wrong.', 'error')
              VueCookie.delete('userData')
              setTimeout(() => {
                this.$router.push('/')
              }, 3000)
            } else {
              this.toastAlert('Your password has been reset successfully', 'success')
              VueCookie.delete('userData')
              this.$store.state.forEmailVerification = false
              this.$store.state.forAdminApproval = false
              setTimeout(() => {
              this.$router.push('/')
              }, 3000)
            }
          })
        }
        })
      }
    },
    components: {
      Layout2
    },
    watch: {
      password () {
        this.rules.map((e, i) => {
          this.rules[i].value = e.regex.test(this.password)
        })
      },
      rules: {
        handler () {
          this.progress = 0
          this.rules.map((e) => {
            if (e.value) {
              this.progress += 20
            }
          })
        },
        deep: true
      }
    },
  }
  </script>
  
  <style>
  
  </style>
  